import React from "react";
import {Card} from 'react-bootstrap'

function STCCardTitle(props){

    return(
        <Card.Title
            style={props.style}
            className={props.className}

            as={props.as}
            bsPrefix={props.bsPrefix}
        >
            {props.children}
        </Card.Title>
    )
}
export default STCCardTitle;